// A list capped at `initial` rows that grows by `step` per click and never
// past `total`, and the button that grows it. One pair for every capped table
// -- the Trips page's cards and the place-visits tables -- so "Show more" is
// the same control, with the same step, wherever it appears.
//
// The hook holds a COUNT, not a slice: the caller slices its own rows, which
// keeps the rows' identity and sort with the caller and lets `total` shrink
// (a filter, a refetch) without the count going stale -- `shown` is clamped
// on every render.

import { useState } from 'react';
import Button from 'react-bootstrap/Button';

// Rows revealed per click.
export const SHOW_MORE_STEP = 10;

export function useShowMore(total, initial, step = SHOW_MORE_STEP) {
  const [count, setCount] = useState(initial);
  return {
    shown: Math.min(total, count),
    canShowMore: count < total,
    showMore: () => setCount((c) => c + step),
  };
}

export const ShowMore = ({ onClick }) => (
  <div className="text-center mt-2">
    <Button variant="outline-secondary" size="sm" onClick={onClick}>Show more</Button>
  </div>
);

export default ShowMore;
